import { Button, MenuItem } from '@mui/material';
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';
import { PopupMenu } from '@/components/atoms';

type Props = {
  value: string;
  languageCodeList?: string[];
  onChange: (languageCode: string) => void;
};

const langCodeInfo = {
  ja: {
    name: '日本語',
    flag: 'JP',
  },
  en: {
    name: 'English',
    flag: 'US',
  },
} as any;

const LanguageSelector = (props: Props) => {
  const langMenu = usePopupState({ variant: 'popover', popupId: 'langMenu' });

  const defaultLangCodeList = Object.keys(langCodeInfo);
  const langCodeList = props.languageCodeList || defaultLangCodeList;

  return (
    <>
      <Button color="inherit" {...bindTrigger(langMenu)} sx={{ width: '100px' }}>
        {langCodeInfo[props.value].name}
      </Button>
      <PopupMenu {...bindMenu(langMenu)}>
        {langCodeList.map((langCode) => (
          <MenuItem key={langCode} onClick={() => props.onChange(langCode)}>
            {langCodeInfo[langCode].name}
            {` (${langCode})`}
          </MenuItem>
        ))}
      </PopupMenu>
    </>
  );
};
export default LanguageSelector;
